@if (true) {
<div class="p-t-0 p-b-10-x p-b-10-l"
     [ngClass]="[component?.bg_color || '', variant === variantTypes.textHeader ? 'p-b-16-l' : 'p-b-10-l']">
    <div class="wrap-x wrap-l">
        @if (isFullImage || (isImageAndText && app.client.sizeId < 2))
          {
          <div
          class="ratio-16-9-s ratio-16-9-m ratio-3-1"
          [ngClass]="component?.bg_color || ''">
            <local-shell />
            @if (isFullImage) {
            <href [link]="component?.image_url">
                <img class="rf"
                     [image]="plpBanner">
            </href>
            }
            <ng-container *ngTemplateOutlet="texts"></ng-container>

            @if (isImageAndText) {
            <div class="fill flex flex-middle"
                 [ngClass]="'flex-justify-' + component?.image_align || 'left' ">
                <div class="w-6 w-12-s w-12-m ratio-16-9">
                    <local-shell />
                    <href [link]="component?.image_url">
                        <img class="rf"
                             [image]="plpBanner">
                    </href>
                </div>
            </div>
            }
    </div>
    }
    @if (isImageAndText && app.client.sizeId > 1) {
    <div class="flex flex-middle"
         [ngClass]="[component?.bg_color || '', isReversed ? 'flex-reverse' : '']">
        <div class="c-6 m-b-0"
             [ngClass]="{'m-r-0' : isReversed}">
            <ng-container *ngTemplateOutlet="texts" />
        </div>
        <div class="c-6 m-b-0 ratio-16-9"
             [ngClass]="{'m-r-0' : !isReversed}">
            <local-shell />
            <href [link]="component?.imageUrl">
                <img class="rf"
                     [image]="plpBanner">
            </href>
        </div>
    </div>
    }
    @if (variant === variantTypes.textHeader || app.client.sizeId < 2){
      <div
      class="wrap-m wrap-s"
      [ngClass]="[component?.bg_color || '', 'flex-justify-' + component?.caption_align || 'left', 'ta-' + component?.caption_align || 'left']">
        <div class="flex flex-column">
            <h1 class="m-t m-t-10-x m-t-10-l m"
                [ngClass]="component?.color || 'col-1'"
                sizeClass="XL:h2, MS:h4">
                {{component?.title | facetOverride : category?.id : 'h1'}}</h1>

            <read-more class="w-12 m-b-6 m-b-3-s m-t m-t-3-s m-t-3-m p1"
                       [ngClass]="component?.color || 'col-1'"
                       [text]="component?.subtitle | facetOverride : category?.id : 'description'"
                       [limit]="component?.subtitleLimit || ((client.isM || client.isS) ? 50 : 200)"
                       readMore="..."
                       readLess="">
            </read-more>
        </div>
        <!-- quick links carousel on all variants on SM and on variant 3 desktop and mobile-->
        @if (quicklinks) {
        <div class="p-b-7">
            <div class="plp-quicklinks">
                <carousel [ngClass]="'carousel-justify-' + component?.caption_align || 'left'"
                          [slidesPerView]="'auto'"
                          [navigation]="false"
                          [spaceBetween]="20"
                          [scrollbar]="false"
                          [loop]="false">
                    @for (link of quickLinks; track link) {
                    <ng-template class="p-b-0 m-r-4"
                                 swiperSlide>
                        <href class="inline-block no-wrap b-b cursor-pointer"
                              [ngClass]="[component?.color || 'col-1', component?.color ? 'b-' + component?.color : 'b-col-1']"
                              sizeClass="XL:p1, MS:p2"
                              [link]="link.quick_link_url"><span *iCms="'quick_link_copy' of link"></span></href>
                    </ng-template>
                    }
                </carousel>
            </div>
        </div>
        }
</div>
}
</div>
</div>
}

<ng-template #texts>

    <!-- add dynamic class flex-justify-left / center / right from cms -->
    @if(client.isX || client.isL) {
    <div class="flex flex-middle"
         [ngClass]="['flex-justify-' + component?.caption_align || 'left', 'ta-' + component?.caption_align || 'left', isImageAndText ? 'p-l-0 p-r-0' : 'p-l-20 p-r-20', isFullImage ? 'fill' : '']">


        <div class="flex flex-column z-2"
             [ngClass]="[isFullImage && readMoreOpen ? 'w-12' : 'w-5', isImageAndText ? 'w-12' : '']">

            <h1 class="h2 m-b"
                [ngClass]="component?.color || ''">{{component?.title | facetOverride : category?.id :
                'h1'}}</h1>

            <read-more class="p1 w-12 m-b-8"
                       [text]="component?.subtitle | facetOverride : category?.id : 'description'"
                       [limit]="component?.subtitleLimit || 200"
                       (visibleUpdate)="onReadMoreVisibilityUpdate($event)"
                       [ngClass]="component?.color || ''"
                       readMore="..."
                       readLess="">
            </read-more>

            <!-- quick links -->
            @if (quicklinks) {
            @if(client.isX || client.isL) {
            <div class="flex"
                 [ngClass]="'flex-justify-' + component?.caption_align || 'left'">
                <div class="flex flex-wrap w-12"
                     [ngClass]="'flex-justify-' + component?.caption_align || 'left'">
                    @for (link of quickLinks; track link) {
                    <href class="p1 inline-block p-b-1 m-r m-b-5 m-b-4-s no-wrap b-b cursor-pointer"
                          [ngClass]="['b-' + (component?.color || 'col-b') || '', component?.color || '']"
                          [link]="link.quick_link_url"> <span *iCms="'quick_link_copy' of link"></span></href>
                    }
                </div>
            </div>
            }
            }
        </div>
    </div>
    }
</ng-template>